import { render, staticRenderFns } from "./screenshot-dialog.vue?vue&type=template&id=63456ee3"
import script from "./screenshot-dialog.vue?vue&type=script&lang=js"
export * from "./screenshot-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports